import React from 'react'
import isMobile from 'ismobilejs'
import { FormattedMessage } from 'react-intl'

import { scroll } from '../../lib/utils'
import Media from '../../sections/media'
import Footer from '../../sections/footer'
import WaveContainer from '../../components/wave-container'

import SignupForm from '../free-start/components/signup-form'

import Faq from './components/Faq'
import Hero from './components/hero'
import Intro from './components/intro'
import WhyFree from './components/why-free'
import Features from './components/features'
import SubFeatures from './components/subfeatures'
import HowItWorks from './components/how-it-works'
import FeatureGrid from './components/feature-grid'
import Seo from '../../components/seo'

interface IFreeProps {
  variant?: 1 | 2
}

const Free: React.FC<IFreeProps> = ({ variant = 1 }) => {
  const signupRef = React.createRef<HTMLDivElement>()

  React.useEffect(() => {
    if (window.location.search.includes('bankidsessionid')) {
      setTimeout(() => {
        scroll(signupRef)
      }, 1000)
    }
  }, [signupRef])

  const clientIsMobileOrTablet = isMobile().phone || isMobile().tablet

  return (
    <>
      <Seo
        description="Gratis faktureringsprogram som gör det enklare att sköta din fakturering, helt online. Med flera smidiga betalsätt för din kund får du dessutom betalt snabbare."
        image="https://www.dooer.com/images/og/og_billing.jpg"
        title="Gratis fakturering | Faktureringsprogram online | Dooer"
        url="https://www.dooer.com/fakturering"
      >
        {variant === 2 && <meta content="noindex" name="robots" />}
        {variant === 2 && <meta content="noindex" name="googlebot" />}
      </Seo>

      <Hero cta={() => scroll(signupRef, 'start')} variant={variant} />
      <WaveContainer>
        <Intro />
        {variant === 2 && <Media larger />}
      </WaveContainer>
      <WaveContainer>
        <Features />
      </WaveContainer>
      <SubFeatures handleClickRegister={() => scroll(signupRef)} />
      <HowItWorks />
      <FeatureGrid />

      <div ref={signupRef}>
        <SignupForm
          apps={['billing', 'sales']}
          event="signup-billing"
          onAfterSubmit={() => {
            if (clientIsMobileOrTablet) {
              scroll(signupRef, 'start')
            }
          }}
          testimonals
          title={
            <FormattedMessage defaultMessage="Kom igång direkt" id="diy-billing.signup-form.heading" tagName="h3" />
          }
        />
      </div>

      <WhyFree />
      <Faq />
      {(!variant || variant === 1) && <Media />}
      <Footer inverted={variant === 2} />
    </>
  )
}

export default Free
